import {API_ROOT} from "../../baseUrls";
import {REMOVE_ITEMS, UPDATE_MINDFILE_ITEM} from "./actionTypes";

export const LIST_SURVEYS = 'LIST_SURVEYS'
export const ADD_SURVEY = 'ADD_SURVEY'
export const LOAD_SURVEY = 'LOAD_SURVEY'
export const ANSWER_SURVEY = 'ANSWER_SURVEY'

let LOADING_SURVEYS = false;
export function listSurveys(mindfileId, callback=()=>{}) {
  return function(dispatch, getState) {
    if(LOADING_SURVEYS){
      return;
    }
    LOADING_SURVEYS = true;
    fetch(`${ API_ROOT }/surveys/${ mindfileId }/list`, {
      method: 'POST',
      credentials: 'include',
      headers: {'X-CSRF-Token': getState().auth.authenticity_token},
    })
      .then(resp => resp.json())
      .then(data => {
        data.surveys.forEach(survey => survey.attempts = data.attempts[survey.id])
        return data;
        // return ({...data, surveys: data.surveys.map(survey => ({...survey, attempts: data.attempts[survey.id]}))})
      })
      .then(data => {
        dispatch({type: LIST_SURVEYS, payload: data});
      })
      .catch((e) => console.error(e))
      .finally(() => {
        LOADING_SURVEYS = false;
        callback();
      });
  }
}

export function startSurvey(mindfileId, folderId, surveyId, callback = () => {}) {
  return function(dispatch, getState) {
    return fetch(`${ API_ROOT }/surveys/${ mindfileId }/add/${surveyId}`, {
      method: 'POST',
      credentials: 'include',
      headers: {
        "Content-Type": "application/json",
        'X-CSRF-Token': getState().auth.authenticity_token
      },
      body: JSON.stringify({
        folder_id: folderId
      }),
    })
      .then(resp => resp.json())
      .then(data => {
        const {mindfile_item, ...item_data} = data
        dispatch({type: UPDATE_MINDFILE_ITEM, payload: {...mindfile_item, item_data: item_data}});
        dispatch({type: ADD_SURVEY, payload: data});
        return data;
      })
      .then(data => callback(data))
      .catch((e) => {
        console.error(e);
        callback(null)
      });
  }
}

export function loadSurvey(mindfileId, attemptId, callback = () => {}) {
  return doLoadSurvey(`/surveys/${ mindfileId }/load/${attemptId}`, callback)
}

export function loadSurveyShare(shareHash, callback = () => {}) {
  return doLoadSurvey(`/share/surveys/load/${shareHash}`, callback)
}

function doLoadSurvey(url, callback = () => {}) {
  return function(dispatch, getState) {
    return fetch(`${ API_ROOT }${ url }`, {
      method: 'POST',
      credentials: 'include',
      headers: {'X-CSRF-Token': getState().auth.authenticity_token},
    })
      .then(resp => resp.json())
      .then(data => {
        // dispatch({type: LOAD_SURVEY, payload: data});
        const {mindfile_item, ...item_data} = data
        dispatch({type: UPDATE_MINDFILE_ITEM, payload: {...mindfile_item, item_data: item_data}});
        return data;
      })
      .then(data => callback(data))
      .catch((e) => {
        console.error(e);
        callback(null)
      });
  }
}

export function answerSurvey(mindfileId, attemptId, answer, callback = () => {}) {
  return doAnswerSurvey(`/surveys/${ mindfileId }/answer/${attemptId}`, answer, callback);
}

export function answerSurveyShare(shareHash, answer, callback = () => {}) {
  return doAnswerSurvey(`/share/surveys/answer/${shareHash}`, answer, callback);
}

 function doAnswerSurvey(url, answer, callback = () => {}) {
  return function(dispatch, getState) {
    return fetch(`${ API_ROOT }${url}`, {
      method: 'POST',
      credentials: 'include',
      headers: {
        "Content-Type": "application/json",
        'X-CSRF-Token': getState().auth.authenticity_token
      },
      body: JSON.stringify({
        answer: [answer[0], {...answer[1], values: Object.entries(answer[1].values)}]
      }),
    })
      .then(resp => resp.json())
      .then(data => {
        dispatch({type: ANSWER_SURVEY, payload: data});
        const {mindfile_item, ...item_data} = data
        dispatch({type: UPDATE_MINDFILE_ITEM, payload: {...mindfile_item, item_data: item_data}});
        return data;
      })
      .then(data => callback(data))
      .catch((e) => {
        console.error(e);
        callback(null)
      });
  }
}

export function answerAllSurvey(mindfileId, attemptId, answer, callback = () => {}) {
  return doAnswerAllSurvey(`/surveys/${ mindfileId }/answers/${attemptId}`, answer, callback)
}

export function answerAllSurveyShare(shareHash, answer, callback = () => {}) {
  return doAnswerAllSurvey(`/share/surveys/answers/${shareHash}`, answer, callback)
}

function doAnswerAllSurvey(url, answer, callback = () => {}) {
  return function(dispatch, getState) {
    return fetch(`${ API_ROOT }${ url }`, {
      method: 'POST',
      credentials: 'include',
      headers: {
        "Content-Type": "application/json",
        'X-CSRF-Token': getState().auth.authenticity_token
      },
      body: JSON.stringify({
        answer: answer
      }),
    })
      .then(resp => resp.json())
      .then(data => {
        dispatch({type: ANSWER_SURVEY, payload: data});
        const {mindfile_item, ...item_data} = data
        dispatch({type: UPDATE_MINDFILE_ITEM, payload: {...mindfile_item, item_data: item_data}});
        return data;
      })
      .then(data => callback(data))
      .catch((e) => {
        console.error(e);
        callback(null)
      });
  }
}

export function resetSurvey(mindfileId, attemptId, callback = () => {}) {
  return doResetSurvey(`/surveys/${ mindfileId }/reset/${attemptId}`, callback)
}
export function resetSurveyShare(shareHash, callback = () => {}) {
  return doResetSurvey(`/share/surveys/reset/${shareHash}`, callback)
}
export function doResetSurvey(url, callback = () => {}) {
  return function(dispatch, getState) {
    return fetch(`${ API_ROOT }${ url }`, {
      method: 'POST',
      credentials: 'include',
      headers: {
        "Content-Type": "application/json",
        'X-CSRF-Token': getState().auth.authenticity_token
      },
    })
      .then(resp => resp.json())
      .then(data => {
        dispatch({type: ANSWER_SURVEY, payload: data});
        const {mindfile_item, ...item_data} = data
        dispatch({type: UPDATE_MINDFILE_ITEM, payload: {...mindfile_item, item_data: item_data}});
        return data;
      })
      .then(data => callback(data))
      .catch((e) => {
        console.error(e);
        callback(null)
      });
  }
}

function updateRequiring(newSurvey, state){
  const {requiredBy, groups, surveys} = state;
  if(!requiredBy[newSurvey.id]){
    return;
  }
  const reqs = (requiredBy[newSurvey.id]||[])
    .map(s => groups[s?.group_id]?.surveys?.[s?.survey_id])
    .filter(x => !!x)

  const changed = {}
  reqs.forEach(survey => {
    const locked = isSurveyLocked(survey, surveys, groups);
    if(locked !== survey.locked){
      survey.locked = locked;
      changed[survey.survey_group.id] = true;
    }
  })
  Object.keys(changed).forEach(gId => {
    const group = groups[gId];
    setGroupInfoAncestors(group, state);
  })
}

function setParentChild(group, state){
  if(!group.parent_group_id){
    return group;
  }
  const parent = state.groups[group.parent_group_id];
  const newParent = {...parent, children: { ...parent.children, [group.id]: group }}
  return setParentChild(newParent, state);
}

function updateSurvey(attempt, state, updateFunc) {
  const surveyId = attempt.survey_id;
  const group = state.groups[state.surveys[surveyId]?.survey_group?.id];
  if(!group){
    return state
  }
  const survey = group.surveys[surveyId]
  const newSurvey = {...survey, attempts: updateFunc(survey.attempts, attempt)};
  const newStatus = surveyStatus(newSurvey);
  const statusChanged = survey.status !== newStatus && (survey.status === -1 || newStatus === 1);
  if(statusChanged) {
    newSurvey.status = newStatus;
  }
  const newGroup = {...state.groups[survey.survey_group.id], surveys: {...state.groups[survey.survey_group.id].surveys, [newSurvey.id]: newSurvey}};
  const newRoot = setParentChild(newGroup, state);

  const newState = {
    ...state,
    surveys: {...state.surveys, [newSurvey.id]: newSurvey},
    groups: {...state.groups, [survey.survey_group.id]: newGroup},
    root: {...state.root, [newRoot.id]: newRoot }
  };

  if(statusChanged) {
    updateRequiring(newSurvey, newState);
    setGroupInfoAncestors(newGroup, newState);
  }
  return newState;
}

function addUsed(surveyGroup, usedGroups){
  if(Object.keys(surveyGroup.surveys).length > 0){
    usedGroups[surveyGroup.id] = surveyGroup;
    return true;
  }
  for(const id in surveyGroup.children){
    const isUsed = addUsed(surveyGroup.children[id], usedGroups);
    if(isUsed){
      usedGroups[surveyGroup.id] = surveyGroup;
      return true;
    }
  }
  return false;
}
function removeUnusedChildren(surveyGroup, usedGroups){
  surveyGroup.children = Object.fromEntries(Object.entries(surveyGroup.children).filter(([id, child]) => !!usedGroups[id]));
  Object.values(surveyGroup.children).forEach(child => removeUnusedChildren(child, usedGroups))
}
function addPath(surveyGroup, path=[]){
  surveyGroup.path = path
  const childPath = [...path, surveyGroup.id];
  Object.values(surveyGroup.children).forEach(child => addPath(child, childPath))
}

function surveyStatus(survey, attempts=survey.attempts){
  return typeof (attempts?.answer_count) === "undefined" ? -1
    : attempts?.answer_count >= survey.question_count ? 1
      : 0.5;//attempts?.answer_count / survey.question_count;
}

function isSurveyLocked(survey, surveys, groups){
  const locked = survey.survey_reqs.find(req => {
    const reqSurvey = groups[surveys[req.survey_id]?.survey_group?.id]?.surveys?.[req.survey_id]
    return !reqSurvey || !reqSurvey.attempts || reqSurvey.attempts?.answer_count < reqSurvey.question_count;
  }) && !survey.attempts;
  return !!locked;
}
function groupPath(root, path, id){
  let group = root;
  path.forEach(p => group = group.children?.[p] || group[p])
  return group.children?.[id] || group[id]
}

function setGroupInfoAncestors(surveyGroup, {root, groups}){
  setGroupInfo(surveyGroup)
  const rgroup = groupPath(root, surveyGroup.path, surveyGroup.id);
  rgroup.info = surveyGroup.info;
  if(!!surveyGroup.parent_group_id && !!groups[surveyGroup.parent_group_id]){
    groups[surveyGroup.parent_group_id].children[surveyGroup.id] = surveyGroup;
    setGroupInfoAncestors(groups[surveyGroup.parent_group_id], {root, groups});
  }
}
function setGroupInfo(surveyGroup){
  const unlocked = Object.values(surveyGroup.surveys || {}).filter(survey => !survey.locked)
  let nextSurvey = unlocked.find(survey => survey.status < 1) ||
    Object.values(surveyGroup.children||{}).sort((a,b) => a.order - b.order).find(group => !!group.info.next)?.info.next;

  surveyGroup.info = {}
  surveyGroup.info.next = nextSurvey;
  surveyGroup.info.completedSurveys = Object.values(surveyGroup.surveys || {}).filter(survey => survey.status >= 1).length
  surveyGroup.info.startedSurveys = Object.values(surveyGroup.surveys || {}).filter(survey => survey.status !== -1).length
  surveyGroup.info.completedChildren =
    Object.values(surveyGroup.children || {})
      .map((group) => !group.surveys || Object.keys(group.surveys).length === 0 ? group.info.completedChildren > 0 && group.info.completedChildren >= Object.keys(group.children).length
          : !Object.values(group.surveys || {}).find(survey => survey.status < 1) && (group.info.completedChildren === 0 || group.info.completedChildren >= Object.keys(group.children).length))
      .filter(x => !!x)
      .length
  surveyGroup.info.startedChildren =
    Object.values(surveyGroup.children || {})
      .map((group) => group.info.startedChildren > 0 ? true
        : !!Object.values(group.surveys || {}).find(survey => survey.status !== -1))
      .filter(x => !!x)
      .length
}

function setSurveysLockedStatus(surveyGroup, groups, surveys){
  Object.values(surveyGroup.surveys || {}).forEach(survey => {
    survey.status = surveyStatus(survey);
    survey.locked = isSurveyLocked(survey, surveys, groups);
  })
  Object.values(surveyGroup.children || {}).forEach(child => setSurveysLockedStatus(child, groups, surveys));
  setGroupInfo(surveyGroup)
}

export function surveyGroups(state = {root: [], groups: [], surveys: [], requiredBy:{}}, action) {
  switch (action.type) {
    case LIST_SURVEYS:
      const surveys = Object.fromEntries(action.payload.surveys.map(x => [x.id, x]))
      const reqs = {}
      action.payload.surveys.forEach(survey =>
        (survey.survey_reqs||[]).forEach(req => {
          const rId = req.survey_id;
          if(!reqs[rId]){
            reqs[rId] = []
          }
          reqs[rId].push({survey_id: survey.id, group_id: survey.survey_group.id});
        }))
      const groups = Object.fromEntries(action.payload.groups.map(x => [x.id, {...x, children: {}, surveys: {}}]))
      Object.values(groups).forEach(group => {
        if(!!group.parent_group_id && !!groups[group.parent_group_id]){
          groups[group.parent_group_id].children[group.id] = group;
        }
      })
      action.payload.surveys.forEach(survey => {
        if(!survey.survey_group || !groups[survey.survey_group.id]){
          return;
        }
        groups[survey.survey_group.id].surveys[survey.id] = survey;
      })

      const usedGroups = {};
      Object.values(groups).forEach(group => addUsed(group, usedGroups));
      const rootGroups = Object.fromEntries(Object.entries(usedGroups).filter(([id, group]) => !group.parent_group_id));
      Object.values(rootGroups).forEach(group => removeUnusedChildren(group, usedGroups));
      Object.values(rootGroups).forEach(group => addPath(group));
      Object.values(rootGroups).forEach(group => setSurveysLockedStatus(group, groups, surveys));
      const newState = {...state, root: rootGroups, groups: groups, surveys: surveys, requiredBy: reqs};
      return newState;
    case ADD_SURVEY:
      return updateSurvey(action.payload, state, (attempts, attempt) => ({
          count: (attempts?.count||0)+1,
          answer_count: Math.max(attempt.answer_count, attempts?.answer_count||0),
          created_at: attempt.mindfile_item.created_at,
          item_id: attempt.mindfile_item.id
        }))
    case ANSWER_SURVEY:
      return  updateSurvey(action.payload, state, (attempts, attempt) => ({
          ...(attempts||{ created_at: attempt.mindfile_item.created_at, item_id: attempt.mindfile_item.id}),
          count: attempts?.count||1,
          answer_count: Math.max(attempt.answer_count, attempts?.answer_count||0),
        }))
    case REMOVE_ITEMS:
      return {root: null, groups: null, surveys: null, requiredBy: null};
    default:
      return  state;
  }
}
